import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import './assets/css/main.css';
import { ApolloProvider } from '@apollo/react-hooks';
import 'react-toastify/dist/ReactToastify.css';
import { StudentRoute } from './app/elements';
import './app/register-fa-icons';
import * as pages from './app/pages';
import Main from './Main';
import client from './app/apollo_client';

class App extends React.Component {
  constructor(props) {
    super(props);

    // Configure default axios response handlers.
    const onSuccess = (response) => response;
    const onError = (e) => {
      const status = e.response && e.response.status;
      if (status === 400 && e.response.data.detail) {
        toast.error(e.response.data.detail);
      }
      return Promise.reject(e);
    };
    axios.interceptors.response.use(onSuccess, onError);
  }

  render() {
    if (process.env.REACT_APP_AGUARDANDO) {
      return <pages.WaitingProject />;
    }

    if (process.env.REACT_APP_COMMIT_ID) {
      localStorage.setItem('commitSHA', process.env.REACT_APP_COMMIT_ID);
    }

    return (
      <ApolloProvider client={client}>
        <BrowserRouter>
          <>
            <ToastContainer />
            <Switch>
              <Route path="/404" component={pages.NotFound} />
              <Route path="/login" component={pages.Login} />
              <Route path="/logon" component={pages.Logon} />
              <Route
                exact
                path="/reset-password"
                component={pages.ResetPassword}
              />
              <Route
                exact
                path="/reset-password/:token"
                component={pages.ResetPassword}
              />
              <StudentRoute
                exact
                path="/inscrever/:token"
                component={pages.Enroll}
              />
              <StudentRoute exact path="/faq/:token" component={pages.Faq} />
              <StudentRoute
                exact
                path="/encerramento"
                component={pages.EndProject}
              />
              <Main />
            </Switch>
          </>
        </BrowserRouter>
      </ApolloProvider>
    );
  }
}

export default App;
